import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProcedureInstanceBase } from '../../model/procedure-instance/procedure-instance.model';
import { IdNameCacheSimpleInfoBase } from '../../model/cache/id-name-simple-info.model';
import { ElementCacheType } from '../../model/cache/element-cache-type.model';
import { ElementCacheService } from '../cache/element-cache.service';

@Injectable({
    providedIn: 'root'
})
export class ProcedureInstanceService {

    protected resourceUrl: string = "/rest/publicarea/procedure-instance"

    constructor(private http: HttpClient, protected elementCacheService: ElementCacheService) { }

    public processFieldsNameInfo(content: ProcedureInstanceBase[]) {
        let entityInfo: IdNameCacheSimpleInfoBase[] = []
        let serviceInfo: IdNameCacheSimpleInfoBase[] = []
        let procedureInfo: IdNameCacheSimpleInfoBase[] = []

        content.forEach(px => {
            entityInfo.push(px.namesInfo.promoterEntity);
            entityInfo.push(px.namesInfo.receptorEntity);
            serviceInfo.push(px.namesInfo.serviceName);
            procedureInfo.push(px.namesInfo.procedureName);
        });
        this.elementCacheService.getSimpleInfo(entityInfo, ElementCacheType.Entity).subscribe(r => {
            //done
        });
        this.elementCacheService.getSimpleInfo(serviceInfo, ElementCacheType.Service).subscribe(r => {
            //done
        });
        this.elementCacheService.getSimpleInfo(procedureInfo, ElementCacheType.Procedure).subscribe(r => {
            //done
        });
    }

}
